/**
 * Build a cookie string for assignment to document.cookie.
 *
 * @param {string} name
 * @param {string} value
 * @param {number} [days] - Days until expiry. Omit for session cookie.
 * @returns {string} Cookie string ready for document.cookie assignment
 */
export function buildCookieString(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  return `${name}=${value || ''}${expires}; path=/`;
}

/**
 * Parse a cookie value from a cookie string (e.g. document.cookie).
 *
 * @param {string} name - Cookie name to find
 * @param {string} cookieString - The full cookie string (semicolon-separated)
 * @returns {string|null} Cookie value, or null if not found
 */
export function parseCookie(name, cookieString) {
  const nameEQ = `${name}=`;
  const ca = cookieString.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
